import { GWTableApiParams, TableProPlusPropsOnChangeParams } from "./dto";
import { TableProPlus } from "@gw/web-basic-components";

const { isOrderTypeValue, isFilterTypeValue, Order } = TableProPlus;

const filterValueHelper = {
  toApi(state: TableProPlusPropsOnChangeParams): GWTableApiParams {
    const orders = state.filterValueList
      .filter(isOrderTypeValue)
      .reduce((prev, curr) => {
        prev.push({ asc: curr.value.order === Order.Ascend, column: curr.key });
        return prev;
      }, [] as GWTableApiParams["orders"]);

    const queryConditions = state.filterValueList
      .filter(isFilterTypeValue)
      .reduce((prev, curr) => {
        prev.push({
          column: curr.key,
          matchType: curr.value.matchType as IMatchType,
          matchValue: curr.value.matchValue,
        });
        return prev;
      }, [] as GWTableApiParams["queryConditions"]);

    return {
      current: state.pagination?.current,
      size: state.pagination?.pageSize,
      orders,
      queryConditions,
    };
  },
};

export default filterValueHelper;
